const trim = function (string) {
  return (string || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
};

// Find components upward
function findComponentUpward(context, componentName, componentNames) {
  if (typeof componentName === "string") {
    componentNames = [componentName];
  } else {
    componentNames = componentName;
  }

  var parent = context.$parent;
  var name = parent.$options.name;
  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}

// Find components downward
function findComponentsDownward(context, componentName) {
  return context.$children.reduce(function (components, child) {
    if (child.$options.name === componentName) components.push(child);
    var foundChilds = findComponentsDownward(child, componentName);
    return components.concat(foundChilds);
  }, []);
}

function oneOf(value, validList) {
  for (var i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

function hasClass(el, clsName) {
  return !!(
    el &&
    (el.className || "")
      .split(" ")
      .map((cls) => cls.trim())
      .includes(clsName)
  );
}

function addClass(el, cls) {
  if (!el) return;
  let curClass = el.className;
  const classes = (cls || "").split(" ");

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += " " + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  const classes = cls.split(" ");
  let curClass = " " + el.className + " ";

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(" " + clsName + " ", " ");
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

const SUPPORT_CURRENCY_SYMBO = {
  HKD: "HK$",
  USD: "US$",
  TWD: "NT$",
  SGD: "S$",
  CNY: "¥",
  AUD: "AUD",
  GBP: "£",
  LAK: "₭",
  EUR: "€",
  THB: "฿",
  NZD: "NZ$",
  MYR: "RM",
  JPY: "¥",
  AED: "AED",
  PHP: "₱",
  KRW: "₩",
  VND: "₫",
  IDR: "Rp",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  CHF: "CHF",
  TRY: "YTL",
  ISK: "kr",
  INR: "₹",
  KHR: "KHR",
  MMK: "BUK",
  MOP: "MOP$",
  QAR: "QR",
  OMR: "OMR",
  JOD: "JOD",
  FJD: "$",
  CAD: "CAD",
  MUR: "Rs",
  MXN: "$",
  MAD: "DH",
  EGP: "EGP",
  ZAR: "R",
  MGA: "MGA",
};

function formatThousands(n = 0, formatter = ",") {
  if (!n) return "0";
  const number = n.toString();
  // 如果价格中包含 ',' 则直接返回价格
  if (number.includes(",")) {
    return number;
  }
  if (number.includes(".")) {
    const numberArray = number.split(".");
    return `${numberArray[0].replace(/(?=(?!(\b))(\d{3})+$)/g, formatter)}.${
      numberArray[1]
    }`;
  }

  return number.replace(/(?=(?!(\b))(\d{3})+$)/g, formatter);
}

function formatPriceThousands(price) {
  price = (price || "0").toString();
  let tmp;
  if (!price.includes(".")) {
    tmp = formatThousands(price);
  } else {
    const prices = price.split(".");
    tmp = `${formatThousands(prices[0])}.${prices[1]}`;
  }
  return tmp;
}

export {
  findComponentUpward,
  findComponentsDownward,
  oneOf,
  hasClass,
  addClass,
  removeClass,
  SUPPORT_CURRENCY_SYMBO,
  formatPriceThousands,
};
